import { Icon } from '@ps/isp-web-component-library';
import { CloseSmall } from '@ps/isp-web-component-library/icons/CloseSmall';
import { SearchMenu } from '@ps/isp-web-component-library/icons/SearchMenu';
import { Translation } from '@ps/web-shared-components';
import { useLayout } from '@ps/web-sports-utils';
import classNames from 'clsx';
import type React from 'react';

import { TXTWCL_Close, TXTWCL_Search } from '../../translations';
import type { Props as HorizontalMenuItemProps } from '../HorizontalMenuItem/HorizontalMenuItem';
import HorizontalMenuItem from '../HorizontalMenuItem/HorizontalMenuItem';

import styles from './SportsMenuToggleButton.module.scss';

type Props = Partial<HorizontalMenuItemProps>;

const SportsMenuToggleButton: React.FC<Props> = () => {
  const { showNavigationSection, setShowNavigationSection } = useLayout();

  return (
    <HorizontalMenuItem
      icon={<Icon icon={showNavigationSection ? CloseSmall : SearchMenu} size="x2.5" />}
      key="search-menu"
      onClick={() => {
        setShowNavigationSection(!showNavigationSection);
      }}
      text={<Translation {...(showNavigationSection ? TXTWCL_Close : TXTWCL_Search)} />}
      className={classNames(styles.sportsMenuToggleButton, {
        [styles.open]: showNavigationSection
      })}
    />
  );
};

export default SportsMenuToggleButton;
